/* eslint-disable quotes */
/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import {
  Table,
  Spin,
  DatePicker,
  Space,
  Tooltip,
  Button,
  Input,
  Select,
} from "antd";
import useCustomNavigate from "../../../components/customNavigationHook";
import API from "../../../api";
import urls from "../../../api/urls";
import constants from "../../../constants/constants";
import moment from "moment";
import { dateFormat_dmy } from "../../../utils";
import PRSAssignDA from "../PRSAssignDA/PRSAssignDA";
const { RangePicker } = DatePicker;
const { PRS_LIST } = urls;
const { ROLES } = constants;
const { CP_ADMIN, CP_OPERATOR, DP_OPERATOR, HO_ADMIN } = ROLES;

import { ReactComponent as View_icon } from "../../../assests/images/SVG/view-details.svg";
import search_icon from "../../../assests/images/search-icon.svg";
import "./prsList.scss";

const prsStatus = {
  PRS_PENDING: "PRS Pending",
  PRS_ASSIGN_TO_DA: "PRS Assign to DA",
  PRS_IN_PROGRESS: "PRS In Progress",
  PRS_PARTIAL_PICKEDUP: "PRS Partial Picked Up",
  PRS_PICKEDUP: "PRS Picked Up",
  PRS_DELIVERED_AT_HUB: "PRS Delivered at Hub",
  PRS_FAILED_TO_PICKUP: "PRS Failed to Pick Up",
  PRS_DELIVERED_EXTERNALLY: "PRS Delivered Externally",
};

const getDpTypeByRole = (roles = []) => {
  if (roles.includes(CP_ADMIN) || roles.includes(CP_OPERATOR)) {
    return "COURIER";
  }
  if (roles.includes(DP_OPERATOR)) {
    return "ECOMM";
  }
  if (roles.includes(HO_ADMIN)) {
    return "COURIER,ECOMM,CARGO";
  }
  return "";
};

const PRSList = ({ tabValue, dpType: dpTypeProp }) => {
  const navigate = useCustomNavigate();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageNum, setPageNum] = useState(0);
  const userId = JSON.parse(localStorage.getItem("userId"));
  const userinfo = JSON.parse(localStorage.getItem("userinfo"));
  const isHOAdmin = userinfo?.roles?.includes(HO_ADMIN);
  const [dateRange, setDateRange] = useState({
    startDate: moment(new Date(), dateFormat_dmy),
    dateFormat_dmy,
    endDate: moment(new Date(), dateFormat_dmy),
  });
  const [isAssignDAModalOpen, setIsAssignDAModalOpen] = useState(false);
  const [selectedPRS, setSelectedPRS] = useState(null);

  useEffect(() => {
    getTableData();
  }, [tabValue, dpTypeProp]);

  const getTableData = async (p1 = 10, p2 = 0, customParams) => {
    const userRoles = userinfo?.roles || [];
    const dpType = dpTypeProp || getDpTypeByRole(userRoles);

    let queryParams;
    if (customParams) {
      queryParams = customParams;
    } else {
      queryParams = new URLSearchParams({
        page: (p2 + 1).toString(),
        limit: p1.toString(),
        startDate: moment(dateRange.startDate).format("MM-DD-YYYY"),
        endDate: moment(dateRange.endDate).format("MM-DD-YYYY"),
        type: dpType,
        ...(tabValue === "unassigned"
          ? { status: "PRS_PENDING" }
          : {
              status:
                "PRS_ASSIGN_TO_DA,PRS_IN_PROGRESS,PRS_PARTIAL_PICKEDUP,PRS_PICKEDUP,PRS_DELIVERED_AT_HUB,PRS_FAILED_TO_PICKUP",
            }),
      });
    }
    // const result = await API.Api(`${PRS_LIST}?${queryParams.toString()}`).get();
    const result = await API.Api(
      `${PRS_LIST}?${queryParams.toString()}`,
    ).getwithParams(queryParams, { kid: "1", authtype: "jwt" });
    const response = result?.response?.data;
    if (response) {
      setTotal(response?.data?.totalCount);
      setTableData(response?.data?.prsList);
    }
  };

  const handleAssignDA = (prsData) => {
    setSelectedPRS(prsData);
    setIsAssignDAModalOpen(true);
  };

  const columns = [
    {
      title: "PRS Number",
      dataIndex: "prsNumber",
      key: "prsNumber",
      render: (text) => <a onClick={() => handlePrsClick(text)}>{text}</a>,
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      render: (text) => moment(text).format("DD/MM/YYYY hh:mm A") || "N/A",
    },
    {
      title: "Updated Date",
      dataIndex: "modifiedAt",
      key: "modifiedAt",
      render: (text) => moment(text).format("DD/MM/YYYY hh:mm A") || "N/A",
    },
    {
      title: "Hub Name",
      dataIndex: "dropInfo",
      key: "hubName",
      render: (text, record) => {
        if (!record?.dropInfo) return "N/A";

        const hubName = record.dropInfo.name;
        return hubName && hubName.toString().trim() !== "" ? hubName : "N/A";
      },
      width: 150,
    },
    {
      title: "Seller Name",
      dataIndex: "sellerInfo",
      key: "sellerInfo",
      render: (text, record) => {
        if (!record?.sellerInfo) return "N/A";

        const sellerFields = [
          record.sellerInfo.name,
          record.sellerInfo.companyName,
        ];

        const nonEmptyFields = sellerFields.filter(
          (field) => field && field.toString().trim() !== "",
        );

        if (nonEmptyFields.length === 0) return "N/A";

        if (nonEmptyFields.length === 2) {
          return `${nonEmptyFields[0]} (${nonEmptyFields[1]})`;
        } else {
          return nonEmptyFields[0];
        }
      },
      width: 200,
    },
    {
      title: "Pickup Address",
      dataIndex: "pickupInfo",
      key: "pickupInfo",
      render: (text, record) => {
        if (!record?.pickupInfo) return "N/A";

        const addressFields = [
          record.pickupInfo.address1,
          record.pickupInfo.address2,
          record.pickupInfo.city,
          record.pickupInfo.state,
          record.pickupInfo.zip,
        ];

        const nonEmptyFields = addressFields.filter(
          (field) => field && field.toString().trim() !== "",
        );

        return nonEmptyFields.length > 0 ? nonEmptyFields.join(", ") : "N/A";
      },
      width: 200,
    },
    {
      title: "Weight(Kg)",
      dataIndex: "weight",
      key: "weight",
      render: (text) => `${text / 1000} Kg` || "N/A",
      width: 80,
    },
    {
      title: "No. of Orders",
      dataIndex: "awbNumberList",
      key: "noOfOrders",
      render: (text, record) => {
        return record?.awbNumberList?.length || "N/A";
      },
      align: "center",
      width: 80,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => prsStatus[text] || text,
      width: 100,
    },
    ...(tabValue === "all"
      ? [
          {
            title: "Delivery Agent",
            dataIndex: "deliveryAgents",
            key: "deliveryAgents",
            render: (deliveryAgents) => {
              if (deliveryAgents && deliveryAgents.length > 0) {
                const agent = deliveryAgents[0];
                const agentId = agent.deliveryAgentId;
                const name = agent.name;
                return (
                  <div>
                    {name && (
                      <div>
                        {agentId} | {name}
                      </div>
                    )}
                    {!name && ""}
                  </div>
                );
              }
              return "N/A";
            },
            width: 150,
          },
        ]
      : []),
    {
      title: "Action",
      key: "action",
      align: "center",
      className: "actions-col",
      width: 120,
      render: (_, record) => (
        <Space size="middle" align="center">
          {tabValue === "unassigned" && !isHOAdmin && (
            <Button
              className="btn btn-primary"
              type="primary"
              onClick={() => handleAssignDA(record)}
            >
              Assign DA
            </Button>
          )}
          <Tooltip title={"View PRS"} placement="bottom">
            <Button
              type="text"
              className="pointer view-button"
              onClick={() => handlePrsClick(record.prsNumber)}
            >
              <View_icon />
            </Button>
          </Tooltip>
        </Space>
      ),
    },
  ];

  const handlePageChange = (pagination) => {
    const userRoles = userinfo?.roles || [];
    const dpType = dpTypeProp || getDpTypeByRole(userRoles);
    setPageSize(pagination.pageSize);
    setPageNum(pagination.current);

    const queryParams = new URLSearchParams({
      page: pagination.current.toString(),
      limit: pagination.pageSize.toString(),
      startDate: dateRange.startDate
        ? moment(dateRange.startDate, dateFormat_dmy).format("MM-DD-YYYY")
        : moment().format("MM-DD-YYYY"),
      endDate: dateRange.endDate
        ? moment(dateRange.endDate, dateFormat_dmy).format("MM-DD-YYYY")
        : moment().format("MM-DD-YYYY"),
      type: dpType,
      ...(tabValue === "unassigned" && { status: "PRS_PENDING" }),
    });

    getTableData(pagination.pageSize, pagination.current - 1, queryParams);
  };
  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };
  const handlePrsClick = (prsNo) => {
    navigate(`/prs-details/${prsNo}`);
  };

  const handleDateChange = (dates) => {
    if (!dates) {
      // When dates are cleared
      setDateRange({
        startDate: null,
        endDate: null,
      });
      getTableData(pageSize, pageNum);
      return;
    }

    if (dates[0] && dates[1]) {
      // When both dates are selected
      setDateRange({
        startDate: dates[0], // Store the moment object directly
        endDate: dates[1], // Store the moment object directly
      });

      const userRoles = userinfo?.roles || [];
      const dpType = dpTypeProp || getDpTypeByRole(userRoles);

      const queryParams = new URLSearchParams({
        page: (pageNum + 1).toString(),
        limit: pageSize.toString(),
        startDate: dates[0].format("MM-DD-YYYY"), // Format directly from moment object
        endDate: dates[1].format("MM-DD-YYYY"), // Format directly from moment object
        type: dpType,
        ...(tabValue === "unassigned"
          ? { status: "PRS_PENDING" }
          : {
              status:
                "PRS_ASSIGN_TO_DA,PRS_IN_PROGRESS,PRS_PARTIAL_PICKEDUP,PRS_PICKEDUP,PRS_DELIVERED_AT_HUB,PRS_FAILED_TO_PICKUP",
            }),
      });

      getTableData(pageSize, pageNum, queryParams);
    }
  };

  const onSearch = async (e) => {
    const searchQuery = e.target.value;
    if (searchQuery) {
      const queryParams = new URLSearchParams({
        PRSNumber: searchQuery,
      });
      getTableData(10, 0, queryParams);
    } else {
      getTableData();
    }
  };

  const debounce = (func, delay) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), delay);
    };
  };

  return (
    <Spin spinning={loading}>
      <div className="master-main-container m-1 p-1 prs-list-container">
        <div className="mb-1 header-container">
          <div className="filters-container">
            <RangePicker
              value={
                dateRange.startDate && dateRange.endDate
                  ? [
                      moment(dateRange.startDate, dateFormat_dmy),
                      moment(dateRange.endDate, dateFormat_dmy),
                    ]
                  : null
              }
              format={dateFormat_dmy}
              onClick={(e) => e.stopPropagation()}
              onChange={handleDateChange}
              disabledDate={(current) =>
                current && current > moment().endOf("day")
              }
              className="input-field-style date-range-picker"
            />
            <Select
              className="input-field-style status-filter"
              placeholder="Filter by Status"
              disabled={tabValue === "unassigned"}
              defaultValue={tabValue === "unassigned" ? "PRS_PENDING" : null}
              bordered={false}
              allowClear
              onChange={(value) => {
                const queryParams = new URLSearchParams({
                  page: "1",
                  limit: pageSize.toString(),
                  startDate: dateRange.startDate
                    ? moment(dateRange.startDate).format("MM-DD-YYYY")
                    : moment().format("MM-DD-YYYY"),
                  endDate: dateRange.endDate
                    ? moment(dateRange.endDate).format("MM-DD-YYYY")
                    : moment().format("MM-DD-YYYY"),
                  ...(value && { status: value }),
                });
                setPageNum(0);
                getTableData(pageSize, 0, queryParams);
              }}
            >
              {Object.entries(prsStatus).map(([key, value]) => (
                <Select.Option key={key} value={key}>
                  {value.replace("PRS ", "")}
                </Select.Option>
              ))}
            </Select>
          </div>
          <Input
            placeholder="Search by PRS Number"
            bordered
            style={{ borderRadius: "5px", height: "40px", width: "465px" }}
            suffix={<img src={search_icon} />}
            onChange={(e) => {
              debounce(onSearch, 500)(e);
            }}
          />
        </div>
        <Table
          columns={columns}
          dataSource={tableData}
          pagination={{
            pageSize: pageSize,
            total: total,
            itemRender: itemRender,
            current: pageNum == 0 ? +1 : pageNum,
          }}
          onChange={handlePageChange}
          // scroll={{ x: "max-content" }}
        />
        <PRSAssignDA
          isModalOpen={isAssignDAModalOpen}
          handleCancel={() => setIsAssignDAModalOpen(false)}
          prsData={selectedPRS}
          handleSuccess={getTableData}
        />
      </div>
    </Spin>
  );
};

export default PRSList;
